module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-vertical-641627e0eba8e7169cfcc64d4442e4e9.svg";